module.exports = __webpack_public_path__ + "media/bootstrap-icons/caret-down-square-fill-8e1bbe4a.svg";